'use client';

import { useAtomValue } from 'jotai';
import { LocalMapModalButton } from '@/app/(pages)/results/(pages)/ui/local-map-modal';
import { GlobalMapModalButton } from '@/app/(pages)/results/(pages)/ui/global-map-modal';
import { selectedVerticalTabInfoAtom } from '@/app/_shared/store/universal-search';

export const MapViewButton = () => {
  const selectedVerticalTabInfo = useAtomValue(selectedVerticalTabInfoAtom);
  const category = selectedVerticalTabInfo?.key;

  return (
    <>
      {category === 'LOCAL_ACCOMMODATION' && <LocalMapModalButton />}
      {category === 'GLOBAL_ACCOMMODATION' && <GlobalMapModalButton />}
    </>
  );
};
